'use strict';
//signalrService MIGRADO
angular.module('TurneroApp').component('coDetalleAtencionTurno', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
        idTurnoDetalle: '<'
    }, controller: [
        '$anchorScroll',
        'turnosService',
        'utilsService',
        'derivacionService',
        'TurneroAppConstant',
        'motivosService',
        'signalrDotNetCoreService',
        'usuariosService',
        'agendaService',
        '$mdDialog',
        '$interval',
        '$state',
        '$localStorage',
        '$rootScope',
        '$window',
        function (
            $anchorScroll,
            turnosService,
            utilsService,
            derivacionService,
            TurneroAppConstant,
            motivosService,
            signalrService,
            usuariosService,
            agendaService,
            $mdDialog,
            $interval,
            $state,
            $localStorage,
            $rootScope,
            $window) {

            var ctrl = this;
            //ctrl.bloquearAcciones : variable que bloquea todos los botones cuando esta en true.
            //Cada metodo que espera algo desde la base de datos, debe seterlo en true, hasta que la base responda.
            ctrl.detalleTurnoInfo = {};
            ctrl.TurnosEstados = TurneroAppConstant.Estados.Turno;
            ctrl.TurnosDerivacion = TurneroAppConstant.TipoDerivacion;

            ctrl.$onChanges = function myfunction() {
                if (ctrl.idTurnoDetalle) {
                    ctrl.bloquearAcciones = false;
                    ctrl.getDerivaciones(ctrl.idTurnoDetalle);
                    ctrl.obtenerTurnos(ctrl.idTurnoDetalle);
                }

            }

            ctrl.limpiarpantalla = function () {
                ctrl.bloquearAcciones = false;
                ctrl.cerrarDetalle();
                ctrl.ctrlPadre.limpiarMemoria();
            }

            ctrl.obtenerTurnos = function (Id_Turno) {
                //Procedimiento principal que obtiene los datos del turno que esta en proceso de atencion
                utilsService.swalTitle('Obteniendo detalles del turno', 'info')
                // you could inspect the data to see if what you care about changed, or just update your own scope
                turnosService.Get_Detalle({ 'id_turno': Id_Turno }).$promise.then(function (data) {
                    ctrl.detalleTurnoInfo = data; //almacena el resultado del procedimiento en el objeto detalle de turno info
                    ctrl.FechaHora_DuracionAtencion = ctrl.detalleTurnoInfo.Duracion_Turno ? moment(ctrl.detalleTurnoInfo.Fecha_Ultimo_Movimiento).add(ctrl.detalleTurnoInfo.Duracion_Turno, 'minutes') : null;
                    swal.close();
                }).catch(function (error) {
                    swal.close();
                    ctrl.ctrlPadre.muestraTurnoDetalle(false);
                    utilsService.errores(error);
                });
            };
            ctrl.cerrarDetalle = function () {
                //OCULTA DETALLE Y MUESTRA LA GRILLA DE CONSULTA
                ctrl.ctrlPadre.muestraTurnoDetalle(false);
                ctrl.bloquearAcciones = false;
            };
            
            ctrl.retenerTurno = function (turno) {
                //logica que se ejecuta cuando se clickea Retener Turno
                ctrl.bloquearAcciones = true;
                //pasa el estado del turno a retenido
                turnosService.Put_Turno_Estado({
                    'id_estado': ctrl.TurnosEstados.Retenido,
                    'id_turno': turno.Id_Turno,
                    'hacer_commit': 1,
                    'id_usuario_sesion': ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion,
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                }).$promise.then(function (resultado) {
                    //envio la notificacion hub
                    //actualizo este turno
                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                        });
                    });

                    signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                        hub.invoke('EliminarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                        });
                    });

                    swal({
                        title: 'Retenido',
                        html: "Se ha retenido el turno.",
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Aceptar"
                    });

                    //Se actualiza el puesto en estado puesto salon
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, $localStorage.TurneroApp_UsuarioSesion.Puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    //MOSTRAR DETALLE Y OCULTAR LA GRILLA DE CONSULTA
                    ctrl.bloquearAcciones = false;
                    ctrl.ctrlPadre.muestraTurnoDetalle(false);
                }).catch(function (error) {
                    if (!(error.data && error.data.IsUserSessionException)) {
                        ctrl.bloquearAcciones = false;
                    }
                    ctrl.limpiarpantalla();
                    utilsService.errores(error);
                });
            };

            ctrl.FinalizarAtencion = function (turno, llamar, salir, darTurno) {
                //logica que se ejecuta cuando se clickea Finalizar Turno
                ctrl.bloquearAcciones = true;
                //si el turno tiene asociado un tramite suac actualiza el turno grabando la vinculacion
                if (turno.Id_Tramite_Suac) {
                    turnosService.Put_Turno_Tramite_Suac({
                        'Id_Turno': turno.Id_Turno,
                        'Id_Tramite_Suac': turno.Id_Tramite_Suac,
                        'id_usuario_sesion': ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then().catch(function (error) {
                        ctrl.limpiarpantalla();
                        utilsService.errores(error);
                    });
                }

                utilsService.swalTitle('Finalizando Turno', 'info');

                //ejecuta la finalizacion del turno
                turnosService.Turno_Finalizar_Put({
                    'Id_Turno': turno.Id_Turno,
                    'id_usuario_sesion': ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion,
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                }).$promise.then(function (resultado) {

                    if (darTurno) {
                        var Modalidad = ctrl.detalleTurnoInfo.N_Modalidad
                        if(Modalidad == "On-Line"){
                            Modalidad = "O"
                        }else{
                            Modalidad = "P";
                        }

                        var N_Ciudadano = ctrl.detalleTurnoInfo.N_Usuario_Cidi.replaceAll("-", "");
                        var url = `${$rootScope.urlHostServer}/turnos?idCentroAtencion=${ctrl.detalleTurnoInfo.Id_Centro_Atencion}&tramitePortal=${ctrl.detalleTurnoInfo.Id_Tramite}&modalidad=${Modalidad}&idCodigo=0&n_ciudadano=${N_Ciudadano}`;
                        $window.open(url, '_blank');
                    }

                    //quito el turno de atención
                    ctrl.ctrlPadre.quitarTurnoAtencion(turno.Id_Turno);
                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('QuitarTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                            console.info("Se invocó a QuitarTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a QuitarTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                        });
                    });

                    //quito el turno del llamador
                    signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                        hub.invoke('EliminarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                        });
                    });

                    //Se actualiza el puesto en estado puesto salon
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, $localStorage.TurneroApp_UsuarioSesion.Puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    //console.log("link de la encuesta: ", window.location.protocol + '//' + window.location.hostname + `/encuesta?idTurno=${turno.Id_Turno}&hash=${SHA256(String(turno.Id_Turno))}&idCalificacion=1`);

                    //MOSTRAR LA GRILLA DE CONSULTA Y OCULTAR DETALLE
                    ctrl.ctrlPadre.muestraTurnoDetalle(false);
                    ctrl.bloquearAcciones = false;

                    //Sale del puesto
                    if (salir) {
                        ctrl.ctrlPadre.salirDelPuesto();
                    }
                    //Llama al próximo
                    else if (llamar) {
                        ctrl.ctrlPadre.llamarProximo();
                    }

                    swal.close();
                }).catch(function (error) {
                    ctrl.limpiarpantalla();
                    utilsService.errores(error);
                });
            };

            ctrl.salirConfirmacion = function () {
                swal({
                    title: 'Cierre de Atención',
                    html: '¿Confirma que desea finalizar su sesión de atención? <br/><br/>Los turnos que se hayan derivado a su box se derivarán automáticamente a la agenda en la que se encuentra conectado.',
                    type: 'info',
                    showCancelButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    confirmButtonColor: '#004b81',
                    cancelButtonColor: 'rgb(170, 170, 170)',
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                }).then(function () {

                    ctrl.FinalizarAtencion(ctrl.detalleTurnoInfo, false, true);

                }).catch(function (error) {
                    if (error != "cancel") {
                        utilsService.errores(error);
                        ctrl.limpiarMemoria();
                    }
                    swal.close();
                })
            };

            ctrl.CancelarAtencion = function (turno) {
                //esta funcionalidad muestra el modal para cancelar la atencion de un turno
                ctrl.bloquearAcciones = true;

                swal({//muestra al usuario un mensaje de cancelacion para que este decida proceder o no con la misma
                    title: 'Cancelar atención de turno',
                    html: 'Está por cancelar la atención de este turno. </br> ¿Está seguro que desea hacerlo? <br/> <strong>El turno volverá al estado anterior.</strong>',
                    type: 'warning',
                    showCancelButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    confirmButtonColor: 'rgb(170, 170, 170)',
                    cancelButtonColor: '#004b81',
                    confirmButtonText: "Cancelar Atención",
                    cancelButtonText: "Continuar Atención",
                }).then(function () {
                    //Cancelar Atencion
                    turnosService.Turnos_Cancelar_Atencion({
                        'Id_Turno': turno.Id_Turno,
                        'id_usuario_sesion': ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (resultado) {
                        //actualizo este turno
                        signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                            hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, turno.Id_Turno).then(function () {
                                console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno.Id_Turno + ": " + err.toString());
                            });
                        });

                        signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                            hub.invoke('EliminarTurno', turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                            });
                        });

                        ctrl.ctrlPadre.muestraTurnoDetalle(false);
                        ctrl.bloquearAcciones = false;

                        swal({
                            title: 'Atencion cancelada',
                            html: "Se ha regresado el turno al estado anterior.",
                            type: 'success',
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar"
                        });

                        //Se actualiza el puesto en estado puesto salon
                        signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                            hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, $localStorage.TurneroApp_UsuarioSesion.Puesto.id).then(function () {
                                console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                            });
                        });

                        //REINICIA ID PARA VOLVER A CARGAR CUANDO ENTRE
                        ctrl.detalleTurnoInfo = {};
                        ctrl.ctrlPadre.Id_Turno_Detalle = "";

                    }).catch(function (error) {
                        if (error.data && error.data.IsUserSessionException) {
                            ctrl.limpiarpantalla();
                            utilsService.errores(error);
                        } else {
                            //ctrl.limpiarpantalla();
                            utilsService.errores(error, ctrl.cerrarDetalle);
                        }
                    })
                }, function (error) {
                    //cancel va  a ser el click en "Continuar Atencion"
                    error != 'cancel' ? utilsService.errores(error) : swal.close();
                    ctrl.bloquearAcciones = false;
                });
            };

            /////  DERIVAR TURNO ////
            ctrl.DerivarTurno = function (tipo_derivacion) {
                //Bloqueo botones
                ctrl.bloquearAcciones = true;
                ctrl.derivacionesOpen = false;
                ctrl.Derivacion = { //armo el objeto derivacion con los datos del tipo, usuario que deriva y turno a derivar
                    Id_Tipo_Derivacion: tipo_derivacion,
                    Id_Usuario_Sesion: ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion,
                    Id_Turno: ctrl.detalleTurnoInfo.Id_Turno
                };

                if (tipo_derivacion == ctrl.TurnosDerivacion.Agenda) {//si la derivacion es por agenda
                    derivacionService.Get_Agendas_Derivacion_Combo({
                        'id_agenda': ctrl.detalleTurnoInfo.Id_Agenda
                    }).$promise.then(function (resultado) { //obtengo el listados de agendas a derivar
                        ctrl.Derivacion.Agendas = resultado.Data;
                        ctrl.getMotivosDerivacion(tipo_derivacion);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.bloquearAcciones = false;
                    });
                }
                else if (tipo_derivacion == ctrl.TurnosDerivacion.Grupo_Puestos) {//si la derivacion es por grupo de puestos
                    derivacionService.Get_Grupos_Derivacion_Combo({
                        'id_agenda': ctrl.detalleTurnoInfo.Id_Agenda
                    }).$promise.then(function (resultado) {//obtengo el listado de grupos de puestos posibles para derivar
                        ctrl.Derivacion.Grupos = resultado.Data;
                        ctrl.getMotivosDerivacion(tipo_derivacion);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.bloquearAcciones = false;
                    });
                }
                else if (tipo_derivacion == ctrl.TurnosDerivacion.Puesto) {//si no, la derivacion se hace por puesto, listando los puestos que estan disponibles para derivarles el turno
                    derivacionService.Get_Puestos_Derivacion_Combo({
                        'id_agenda': ctrl.detalleTurnoInfo.Id_Agenda,
                        'id_usuario_sesion': ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion
                    }).$promise.then(function (resultado) {
                        if (resultado.Data) {
                            for (var i = 0; i < resultado.Data.length; i++) {

                                if (resultado.Data[i].En_Atencion != 'S') {
                                    resultado.Data[i].Situacion = ' - Libre';
                                    resultado.Data[i].Style = 'color:green; font-weight: bold;';
                                } else if (resultado.Data[i].En_Pausa == 'S') {
                                    resultado.Data[i].Situacion = ' - Pausado';
                                    resultado.Data[i].Style = 'color:#ffeb3b; font-weight: bold;';
                                } else {
                                    resultado.Data[i].Situacion = ' - Ocupado';
                                    resultado.Data[i].Style = 'color:red; font-weight: bold;';
                                }
                            }
                        }
                        ctrl.Derivacion.Puestos = resultado.Data;
                        ctrl.getMotivosDerivacion(tipo_derivacion);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.bloquearAcciones = false;
                    });
                }
                else if (tipo_derivacion == ctrl.TurnosDerivacion.Tramite) {
                    derivacionService.Get_Tramites_Derivacion_Combo({
                        'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                    }).$promise.then(function (resultado) {
                        ctrl.Derivacion.Tramites = resultado.Data;
                        ctrl.getMotivosDerivacion(tipo_derivacion);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.bloquearAcciones = false;
                    });
                }
            }

            ctrl.getMotivosDerivacion = function (tipo_derivacion) {
                //obtiene el listado de motivos de la derivacion.
                motivosService.GetByTipoMotivo({
                    'id_tipo_motivo': TurneroAppConstant.TipoMotivos.Derivacion
                }).$promise.then(function (data) {
                    ctrl.Derivacion.Motivos = data;

                    if (ctrl.Derivacion.Puestos && ctrl.Derivacion.Puestos.length ||
                        ctrl.Derivacion.Grupos && ctrl.Derivacion.Grupos.length ||
                        ctrl.Derivacion.Agendas && ctrl.Derivacion.Agendas.length ||
                        ctrl.Derivacion.Tramites && ctrl.Derivacion.Tramites.length) {

                        $mdDialog.show({
                            template: require('./modalDerivacion.html'),
                            parent: angular.element(document.body),
                            clickOutsideToClose: false,
                            fullscreen: false, // Only for -xs, -sm breakpoints.,
                            controllerAs: '$ctrl',
                            controller: function () {
                                return ctrl;
                            }
                        });
                    } else {
                        if (tipo_derivacion == ctrl.TurnosDerivacion.Agenda) {
                            swal({
                                title: 'No hay agendas',
                                html: "No se han encontrado agendas para mostrar.",
                                type: 'warning',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Aceptar"
                            });
                        } else if (tipo_derivacion == ctrl.TurnosDerivacion.Grupo_Puestos) {
                            swal({
                                title: 'No hay grupos',
                                html: "No se han encontrado grupos para mostrar.",
                                type: 'warning',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Aceptar"
                            });
                        } else if (tipo_derivacion == ctrl.TurnosDerivacion.Puesto) {
                            swal({
                                title: 'No hay puestos activos',
                                html: "No se han encontrado puestos activos para mostrar.",
                                type: 'warning',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Aceptar"
                            });
                        } else if (tipo_derivacion == ctrl.TurnosDerivacion.Tramite) {
                            swal({
                                title: 'No hay puestos activos',
                                html: "No se han encontrado tramites para mostrar.",
                                type: 'warning',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Aceptar"
                            });
                        }

                        $mdDialog.destroy();
                        ctrl.bloquearAcciones = false;
                    }

                }).catch(function (error) {
                    utilsService.errores(error)
                });
            }

            ctrl.getDerivaciones = function (Id_Turno) {
                //obtiene el listado de tipos de derivaciones posibles
                derivacionService.Get_Tipos_Derivacion_Combo({ 'id_turno': Id_Turno }).$promise.then(function (resultado) {
                    ctrl.TiposDerivaciones = resultado.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                })
            };

            ctrl.PostDerivacion = function () {
                ctrl.bloquearAcciones = true;
                //POST DE DERIVACION.
                derivacionService.Post_Derivar_Turno_Atencion(
                    {
                        'id_usuario_sesion': ctrl.ctrlPadre.UsuarioConfig.Id_Usuario_Sesion,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    },
                    ctrl.Derivacion
                ).$promise.then(function (resultado) {
                    $mdDialog.destroy();

                    //Actualizo la grilla de atencion
                    signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {

                        // Traer los turnos actualizados
                        hub.invoke('TraerTurnos', ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a TraerTurnos en " + TurneroAppConstant.HubNames.TURNOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnos en " + TurneroAppConstant.HubNames.TURNOS + ": " + err.toString());
                        });

                        // Obtener los cambios en el turno
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, ctrl.Derivacion.Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.Derivacion.Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + turno_derivacion.Id_Turno + ": " + err.toString());
                        });

                        //Avisa que hubo una derivacion e informa a los usuarios que les corresponda
                        hub.invoke('TraerTurnoDerivacion', ctrl.centroAtencionSeleccionado.id, ctrl.Derivacion.Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoDerivacion en " + TurneroAppConstant.HubNames.TURNOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoDerivacion en " + TurneroAppConstant.HubNames.TURNOS + ": " + err.toString());
                        });
                    });

                    //Se actualiza el puesto en estado puesto salon
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, $localStorage.TurneroApp_UsuarioSesion.Puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    //se elimina el turno del llamado
                    signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                        hub.invoke('EliminarTurno', ctrl.Derivacion.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                            console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                        });
                    });

                    swal({
                        title: 'Turno derivado',
                        html: "Se ha derivado el turno exitosamente.",
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Aceptar"
                    });
                    ctrl.bloquearAcciones = false;

                    //MOSTRAR LA GRILLA DE CONSULTA
                    ctrl.ctrlPadre.muestraTurnoDetalle(false);

                    //REINICIA ID PARA VOLVER A CARGAR CUANDO ENTRE
                    ctrl.detalleTurnoInfo = {};
                    ctrl.ctrlPadre.Id_Turno_Detalle = "";
                }).catch(function (error) {
                    ctrl.limpiarpantalla();
                    ctrl.cerrarModal();
                    utilsService.errores(error);
                });
            };

            ctrl.onChangeTramiteDerivacion = function () {
                derivacionService.Get_Agendas_X_Tramite_Derivacion_Combo({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id,
                    'id_tramite': ctrl.Derivacion.Id_Tramite_Destino_Deriv
                }).$promise.then(function (resultado) { //obtengo el listados de agendas a derivar
                    ctrl.Derivacion.Agendas = resultado.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                    ctrl.bloquearAcciones = false;
                });
            }

            ctrl.cerrarModal = function () {
                ctrl.Derivacion = null;
                ctrl.Id_tramite_suac = null;
                ctrl.bloquearAcciones = false;
                $mdDialog.destroy();
            };

            //TRAMITE SUAC
            ctrl.getSuacModal = function () {
                $mdDialog.show({
                    template: require('./modalstickerSuac.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false, // Only for -xs, -sm breakpoints.,
                    controllerAs: '$ctrl',
                    controller: function () {
                        return ctrl;
                    }
                });
            };

            ctrl.guardarTramiteSuac = function () {
                //Obtiene el tramite suac a partir del numero de sticker
                if (ctrl.Id_tramite_suac) {
                    ctrl.bloquearAcciones = true;
                    turnosService.Traer_Tramite_Suac({ 'id_nro_sticker': ctrl.Id_tramite_suac }).$promise.then(function (resultado) {
                        if (resultado.Data) {
                            ctrl.detalleTurnoInfo.Id_Tramite_Suac = resultado.Data.Id_Tramite;
                            ctrl.cerrarModal();
                        }
                        else {
                            utilsService.errores({ data: { Message: 'ADV - El número de sticker ingresado no es válido o usted no ha iniciado este trámite.' } })
                        }
                    }).catch(function (error) {
                        utilsService.errores(error);
                        ctrl.bloquearAcciones = false;
                    })
                } else {
                    utilsService.errores({ data: { Message: 'ADV - El número de sticker no puede estar vacío.' } })
                }
            };

            //RELOJ
            function tick() {
                if ($state.$current.name != "admin.atencion") {
                    $interval.cancel(ctrl.ticker);
                } else {
                    if (ctrl.detalleTurnoInfo && ctrl.detalleTurnoInfo.Mostrar_Reloj == 'S' && ctrl.FechaHora_DuracionAtencion) {
                        ctrl.calcTiempoAtencion(ctrl.FechaHora_DuracionAtencion);
                    }
                }
            }

            tick();
            ctrl.ticker = $interval(tick, 1000);

            ctrl.calcTiempoAtencion = function (duracion) {
                var fecha1 = moment(duracion, "YYYY-MM-DD HH:mm:ss");
                ctrl.TiempoNegativo = !(moment().isBefore(fecha1));

                ctrl.CuentaRegresiva = ctrl.TiempoNegativo ? moment(moment() - fecha1).format("mm:ss") : moment(fecha1 - moment()).format("mm:ss");
            };
            //combos de derivacion
            ctrl.searchTermMotivo = {
                text: ''
            };

            ctrl.searchTermAgenda = {
                text: ''
            };

            ctrl.searchTermPuesto = {
                text: ''
            };

            ctrl.searchTermGrupo = {
                text: ''
            };

            ctrl.clearSearchTerm = function () {
                ctrl.searchTermMotivo = {
                    text: ''
                };
                ctrl.searchTermAgenda = {
                    text: ''
                };
                ctrl.searchTermPuesto = {
                    text: ''
                };
                ctrl.searchTermGrupo = {
                    text: ''
                };
            };
        }
    ],
    template: require('./detalleAtencionTurno.html')
});



// WEBPACK FOOTER //
// ./app/components/atencion/detalleAtencionTurnoComponent.js